import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import CriarConta from "./components/pages/Registrar";
import Home from "./components/pages/Menu";
import Unidade from "./components/pages/Unidade";
import Familia from "./components/pages/Familia";
import Armazem from "./components/pages/Armazem";
import FPagamento from "./components/pages/FPagamento";
import Banco from "./components/pages/Banco";
import Veiculo from "./components/pages/Veiculo";
import Conta from "./components/pages/Conta";
import FormaPagamento from "./components/pages/FormaPagamento";
import Imposto from "./components/pages/Imposto";
import Moeda from "./components/pages/Moeda";
import Cambio from "./components/pages/Cambio";
import Produto from "./components/pages/Produto";
import Servico from "./components/pages/Servico";
import Cliente from "./components/pages/Cliente";
import Fornecedor from "./components/pages/Fornecedor";
import Usuario from "./components/pages/Usuario";
import EntradaEstoque from "./components/pages/EntradaEstoque";
import Turno from "./components/pages/Turno";
import CompraFornecedor from "./components/pages/CompraFornecedor";
import Inventario from "./components/pages/Inventario";

 

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Rota de login fora da estrutura protegida */}
        <Route path="/" element={<Login />} />
        <Route path="/criar_conta" element={<CriarConta />} />
  
             
       

        {/* Rotas protegidas dentro de Home */}
        <Route
          path="/*"
          element={
          //  <Home />
          
           <ProtectedRoute>
            <Home />
            </ProtectedRoute>
 

          }
        >
          <Route path="unidades" element={<Unidade />} />
          <Route path="clientes" element={<Cliente />} />
          <Route path="fornecedores" element={<Fornecedor />} />
          <Route path="familias" element={<Familia />} />
          <Route path="armazens" element={<Armazem />} />
          <Route path="finalidades-pagamento" element={<FPagamento />} />
          <Route path="formas-pagamento" element={<FormaPagamento />} />
          <Route path="bancos" element={<Banco />} />
          <Route path="veiculos" element={<Veiculo />} />
          <Route path="contas-bancarias" element={<Conta />} />
          <Route path="impostos" element={<Imposto />} />
          <Route path="moedas" element={<Moeda />} />
          <Route path="cambios" element={<Cambio />} />
          <Route path="produtos" element={<Produto />} />
          <Route path="servicos" element={<Servico />} />
          <Route path="usuarios" element={<Usuario />} />
          <Route path="entrada" element={<EntradaEstoque />} />
          <Route path="turno" element={<Turno />} />
          <Route path="compra-fornecedor" element={<CompraFornecedor />} />
          <Route path="inventario" element={<Inventario />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
